import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { IUser } from 'types/interfaces/iUser';
import { COLOR_PRIMARY } from 'attrs/colors';

import { setConfirmationRequest } from '../../redux/ui/confirmations/actions';
import { deleteUserById } from '../../redux/users/actions';

interface DeleteProps {
  user: IUser;
}

const Delete = ({ user }: DeleteProps) => {
  const dispatch = useDispatch();

  const handleDeleteClick = () => {
    dispatch(
      setConfirmationRequest({
        title: 'dialog.confirmation.title_delete_user',
        subtitle: 'dialog.confirmation.subtitle_delete_user',
        message: 'dialog.confirmation.delete_user',
        delete: 'dialog.confirmation.confirm_delete',
        extraValue: user['e-mail'],
        action: () => dispatch(deleteUserById(user.id))
      })
    );
  };

  return (
    <>
      <IconButton color="primary" aria-label="delete_role" onClick={handleDeleteClick}>
        <DeleteForeverOutlinedIcon htmlColor={COLOR_PRIMARY} />
      </IconButton>
    </>
  );
};

export default Delete;
